import { render, staticRenderFns } from "./SkyboxEntrance.vue?vue&type=template&id=694dfe7a"
import script from "./SkyboxEntrance.vue?vue&type=script&lang=js"
export * from "./SkyboxEntrance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports